import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button,Toast } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { IoIosClose, IoMdDownload } from "react-icons/io";
import ReactTable from "../../../components/FilterTable";
import { _HttpServices } from "../../../_services/_HttpServices";
import Loader from "../../../components/Loader";
// import Loader from "../../components/Loader";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment'
import { useHistory } from 'react-router';
import getExcel from "../../../_services/ExcelUtility";
import { Footer } from "../../../components/Footer";
const OutBoundAptevoServiceFeesPage = () => {
    const fileName = 'Service Fee Source Data';
    const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
    const history = useHistory();
    const [serviceFee, setServiceFee] = useState([]);
    const [loading, setLoading] = useState(false);
    // const [showToaster, setShowToaster] = useState(false);
    // let Message;
    const [hasError, setHasError] = useState(false);
    const columns = [
        
        {
            Header: "Distributor Name",
            accessor: "DistributorName",
            filter: "DistributorName",
            sortType: "basic",
        },
        {
            Header: "Distribution Location State",
            accessor: "DistributionLocationState",
            filter: "DistributionLocationState",
            sortType: "basic",
        },
        {
            Header: "Report Date",
            accessor: "ReportDate",
            filter: "ReportDate",
            sortType: "basic",
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            }
        }, {
            Header: "Debit Memo#",
            accessor: "DebitMemo",
            filter: "DebitMemo",
            sortType: "basic",
        }, {
            Header: "Customer HIN",
            accessor: "Customerhin",
            filter: "Customerhin",
            sortType: "basic",
        },
        {
            Header: "CB Cust PHS ID# (For applicable CBs only)",
            accessor: "CustPHSID",
            filter: "CustPHSID",
            sortType: "basic",
        },
        {
            Header: "Customer Name",
            accessor: "CustName",
            filter: "CustName",
            sortType: "basic",
        },
        {
            Header: "Customer Address",
            accessor: "CustAddress",
            filter: "CustAddress",
            sortType: "basic",
        },
        {
            Header: "Customer City",
            accessor: "CustCity",
            filter: "CustCity",
            sortType: "basic",
        },
        {
            Header: "Customer State",
            accessor: "CustState",
            filter: "CustState",
            sortType: "basic",
        },
        {
            Header: "Customer Zip",
            accessor: "CustZip",
            filter: "CustZip",
            sortType: "basic",
        },
        {
            Header: "Customer Invoice#",
            accessor: "CustomersInvoice",
            filter: "CustomersInvoice",
            sortType: "basic",
        },
        {
            Header: "Customer Invoice Date",
            accessor: "CustomersInvoiceDate",
            filter: "CustomersInvoiceDate",
            sortType: "basic",
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            }
        },
        {
            Header: "Contract Reference",
            accessor: "ContractReference",
            filter: "ContractReference",
            sortType: "basic",
        },
        {
            Header: "Product NDC-11",
            accessor: "ProductNDC",
            filter: "ProductNDC",
            sortType: "basic",
        },
        {
            Header: "Product Description",
            accessor: "ProductDescription",
            filter: "ProductDescription",
            sortType: "basic",
        },
        {
            Header: "Sale QTY",
            accessor: "SaleQTY",
            filter: "SaleQTY",
            sortType: "basic",
        },
        {
            Header: "Sale  QTY UOM",
            accessor: "SaleQTYUOM",
            filter: "SaleQTYUOM",
            sortType: "basic",
        },{
            Header: "DOSAGE/UNITS ",
            accessor: "DosagORUnits",
            filter: "DosagORUnits",
            sortType: "basic",
        },
        {
            Header: "Dosage/Units UOM",
            accessor: "DosageORUnitsUMO",
            filter: "DosageORUnitsUMO",
            sortType: "basic",
        },
        {
            Header: "Total IUs",
            accessor: "IUs",
            filter: "IUs",
            sortType: "basic",
        },
        {
            Header: "Acquisition Cost Per IU/EU/Gram ",
            accessor: "AcquisitionCost",
            filter: "AcquisitionCost",
            sortType: "basic",
            // Cell: ({ row: { original } }) => (
            //     <Fragment>
            //          {original.AcquisitionCost == null?"$0.00":<span>$ {(original.AcquisitionCost*1).toFixed(2)}</span>}
            //      </Fragment>
            //  )
        },{
            Header: "Contract Price Per IU/EU/Gram ",
            accessor: "ContractPrice",
            filter: "ContractPrice",
            sortType: "basic",
            // Cell: ({ row: { original } }) => (
            //     <Fragment>
            //          {original.ContractPrice == null?"$0.00":<span>$ {(original.ContractPrice*1).toFixed(2)}</span>}
            //      </Fragment>
            //  )
        },
        {
            Header: "CIBD Extended Amount",
            accessor: "CIBDExtendedAmount",
            filter: "CIBDExtendedAmount",
            sortType: "basic",
            // Cell: ({ row: { original } }) => (
            //     <Fragment>
            //          {original.CIBDExtendedAmount == null?"$0.00":<span>$ {(original.CIBDExtendedAmount*1).toFixed(2)}</span>}
            //      </Fragment>
            //  )
        },
        {
            Header: "2% ServiceFees",
            accessor: "TwoPercentServiceFees",
            filter: "TwoPercentServiceFees",
            sortType: "basic",
            // Cell: ({ row: { original } }) => (
            //     <Fragment>
            //          {original.TwoPercentServiceFees == null?"$0.00":<span>$ {(original.TwoPercentServiceFees*1).toFixed(2)}</span>}
            //      </Fragment>
            //  )
        }
    ];

    // excel Header
    const excelColumns = [
        
        {
            Header: "DISTRIBUTOR NAME",
            accessor: "DistributorName",
            filter: "DistributorName",
            sortType: "basic",
        },
        {
            Header: "DISTRIBUTION LOCATION STATE",
            accessor: "DistributionLocationState",
            filter: "DistributionLocationState",
            sortType: "basic",
        },
        {
            Header: "REPORT DATE",
            accessor: "ReportDate",
            filter: "ReportDate",
            sortType: "basic",
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            }
        }, {
            Header: "DEBIT MEMO#",
            accessor: "DebitMemo",
            filter: "DebitMemo",
            sortType: "basic",
        }, {
            Header: "customer hin",
            accessor: "Customerhin",
            filter: "Customerhin",
            sortType: "basic",
        },
        {
            Header: "CB CUST PHS ID# (For applicable CBs only)",
            accessor: "CustPHSID",
            filter: "CustPHSID",
            sortType: "basic",
        },
        {
            Header: "CUSTOMER NAME",
            accessor: "CustName",
            filter: "CustName",
            sortType: "basic",
        },
        {
            Header: "CUSTOMER ADDRESS",
            accessor: "CustAddress",
            filter: "CustAddress",
            sortType: "basic",
        },
        {
            Header: "CUSTOMER CITY",
            accessor: "CustCity",
            filter: "CustCity",
            sortType: "basic",
        },
        {
            Header: "CUSTOMER STATE",
            accessor: "CustState",
            filter: "CustState",
            sortType: "basic",
        },
        {
            Header: "CUSTOMER ZIP",
            accessor: "CustZip",
            filter: "CustZip",
            sortType: "basic",
        },
        {
            Header: "CUSTOMER'S INVOICE#",
            accessor: "CustomersInvoice",
            filter: "CustomersInvoice",
            sortType: "basic",
        },
        {
            Header: "CUSTOMER'S INVOICE DATE",
            accessor: "CustomersInvoiceDate",
            filter: "CustomersInvoiceDate",
            sortType: "basic",
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            }
        },
        {
            Header: "CONTRACT REFERENCE",
            accessor: "ContractReference",
            filter: "ContractReference",
            sortType: "basic",
        },
        {
            Header: "PRODUCT NDC-11",
            accessor: "ProductNDC",
            filter: "ProductNDC",
            sortType: "basic",
        },
        {
            Header: "PRODUCT DESCRIPTION",
            accessor: "ProductDescription",
            filter: "ProductDescription",
            sortType: "basic",
        },
        {
            Header: "SALE QTY",
            accessor: "SaleQTY",
            filter: "SaleQTY",
            sortType: "basic",
        },
        {
            Header: "SALE QTY UOM",
            accessor: "SaleQTYUOM",
            filter: "SaleQTYUOM",
            sortType: "basic",
        },{
            Header: "DOSAGE / UNITS",
            accessor: "DosagORUnits",
            filter: "DosagORUnits",
            sortType: "basic",
        },
        {
            Header: "DOSAGE / UNITS UOM",
            accessor: "DosageORUnitsUMO",
            filter: "DosageORUnitsUMO",
            sortType: "basic",
        },
        {
            Header: "Total IUs",
            accessor: "IUs",
            filter: "IUs",
            sortType: "basic",
        },
        {
            Header: "ACQUISITION COST per IU/EU/Gram",
            accessor: "AcquisitionCost",
            filter: "AcquisitionCost",
            sortType: "basic",

        },{
            Header: "CONTRACT PRICE per IU/EU/Gram",
            accessor: "ContractPrice",
            filter: "ContractPrice",
            sortType: "basic",
        },
        {
            Header: "CIBD Extended Amount",
            accessor: "CIBDExtendedAmount",
            filter: "CIBDExtendedAmount",
            sortType: "basic",

        },
        {
            Header: "2% Service Fees",
            accessor: "TwoPercentServiceFees",
            filter: "TwoPercentServiceFees",
            sortType: "basic",
        }
    ];

    // 
    async function headerData(serviceFee) {
        var data_to_download = []
        if(serviceFee != 0){
        serviceFee.map((data, pidex) => {
            let record_to_download = {}
            excelColumns.map((col, cindex) => {
                record_to_download[excelColumns[cindex].Header] = serviceFee[pidex][excelColumns[cindex].accessor]
            })
            data_to_download.push(record_to_download)
        })}
        else {
            let record_to_download = {}
            excelColumns.map((col, cindex) => {
                record_to_download[excelColumns[cindex].Header] = ""
            })
            data_to_download.push(record_to_download)
        }
        exportToCSV(data_to_download)
    }
    const exportToCSV = (data_to_download) => {
        var wscols = [{ wch: 20, color: 'aabbcc' }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 20 }, { wch: 20 }, { wch: 20 }];
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const ws = XLSX.utils.json_to_sheet(data_to_download);
        ws["!cols"] = wscols;
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, "Service Fee Source Data");
    }
     useEffect(() => {
        getServiceFee();
    }, [])
    async function getServiceFee() {
        setLoading(true);
        await _HttpServices
            .getData(`Api/Inbound/OutBoundAptevoServiceFeesSource?fileprocessId=${outbounddata.File_Process_ID}`)
            .then((data) => {
                const serviceFeeResult = data.data;
                if(serviceFeeResult.length > 0){
                    serviceFeeResult.map((res) => { 
                        res.ReportDate = moment(res.ReportDate).format('MM/DD/YYYY') ;
                        res.CustomersInvoiceDate = moment(res.CustomersInvoiceDate).format('MM/DD/YYYY') 
                        res.AcquisitionCost = res.AcquisitionCost == null?"$0.00":"$"+(res.AcquisitionCost*1).toFixed(2);
                        res.ContractPrice=res.ContractPrice == null?"$0.00":"$" + (res.ContractPrice*1).toFixed(2);
                        res.CIBDExtendedAmount=res.CIBDExtendedAmount == null?"$0.00":"$" + (res.CIBDExtendedAmount*1).toFixed(2);
                        res.TwoPercentServiceFees=res.TwoPercentServiceFees == null?"$0.00":"$" + (res.TwoPercentServiceFees*1).toFixed(2);
                        res.DosagORUnits=res.DosagORUnits == null?"0.00": (res.DosagORUnits*1).toFixed(2);
                        res.IUs=res.IUs == null?"0.0000":(res.IUs*1).toFixed(4);
                             
                           
                   
                   
                    })
                    }
                setServiceFee(serviceFeeResult);
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
                // Message = e.response.data.Message;
                // setShowToaster(true);
                setHasError(true);
            });
    }
    return (
        <section className="content">
            <div className="page-title">
                <h2 className="h2">Service Fee Source Data</h2>
                {loading ? <Loader /> : null}

                <Button type="submit" onClick={() => getExcel(excelColumns,serviceFee,fileName)}><IoMdDownload className="icon btn-icon" />Download Excel </Button>

            </div>
            {/* Toaster */}
            {/* <Toast onClose={() => setShowToaster(false)} show={showToaster} delay={1500} autohide className="custom-toaster">
                <Toast.Header>
                    <img
                        src="holder.js/20x20?text=%20"
                        className="rounded mr-2"
                        alt=""
                    />
                    <strong className="mr-auto">Woohoo!!</strong>
                </Toast.Header>
                <Toast.Body>{Message}</Toast.Body>
            </Toast> */}
            <Row>
                <Col md={12}>
                    <div className="card pt-2">
                        <div className="card-body">
                            <div className="inventory-grid">
                            {hasError ? <p>Error occurred. Unable to load Service Fee Source Data.</p> :
                                <Fragment>
                                    {serviceFee.length > 0 ? (
                                        <ReactTable columns={excelColumns} data={serviceFee} defaultPageSize={10} />
                                    ) : (
                                            <div className="no-data">No data found.</div>
                                        )}
                                </Fragment>
                            }
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
              <Col md={12} className="text-right mt-2">
                <Button
                  variant="danger"
                  type="button"
                  className="ml-3"
                   onClick={() => history.goBack()}
                >
                  <IoIosClose className="icon btn-icon" />
                  Cancel
                </Button>
              </Col>
            </Row>
            <Footer />
        </section>
    );

}
export default OutBoundAptevoServiceFeesPage;